<template>
  <div class="flex">
    <Sidebar />
    <div class="w-100 home-content">
      <div class="d-flex justify-content-between p-3 bg-white">
        <div>&nbsp;</div>
        <div class="d-flex">
          <div class="toggle-view-mode" @click="switchMode" v-if="isAdminOrg">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM8 20H4V16H8V20ZM8 14H4V10H8V14ZM8 8H4V4H8V8ZM14 20H10V16H14V20ZM14 14H10V10H14V14ZM14 8H10V4H14V8ZM20 20H16V16H20V20ZM20 14H16V10H20V14ZM20 8H16V4H20V8Z"
                fill="#03267A"
              />
            </svg>
            <p
              class="fs-16 fw-800 txt-grey-700 mb-0 ml-2"
            >{{ mode === 1 ? "Organization View" : "Workspace View" }}</p>
          </div>
        </div>
      </div>
      <div v-if="!type">
        <div class="row">
          <div class="col-lg-8 p-3">
            <div class="welcome-text p-3 bg-white">
              <p class="text-capitalize txt-black mb-2">{{ moment().lang("vi").format("LLLL") }}</p>
              <p
                class="text-capitalize txt-grey-900 fs-20 fw-500 mb-0"
              >Welcome HOME, {{ user && user.name }}</p>
            </div>
          </div>
        </div>
        <div class="row mb-3" v-if="mode === 1">
          <div class="col-12 px-3 d-flex align-items-center">
            <svg
              width="28"
              height="29"
              viewBox="0 0 28 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8.16663 11.5833L14 17.4166L19.8333 11.5833H8.16663Z" fill="#1D2939" />
            </svg>
            <p class="fs-16 txt-grey-700 mb-0">{{ ws && ws.name }}</p>
          </div>
          <div class="col-md-3 p-3">
            <div class="home-item">
              <svg
                width="37"
                height="37"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.5 21.75C18.7967 21.75 19.0867 21.662 19.3334 21.4972C19.58 21.3324 19.7723 21.0981 19.8858 20.824C19.9994 20.5499 20.0291 20.2483 19.9712 19.9574C19.9133 19.6664 19.7704 19.3991 19.5607 19.1893C19.3509 18.9796 19.0836 18.8367 18.7926 18.7788C18.5017 18.7209 18.2001 18.7506 17.926 18.8642C17.6519 18.9777 17.4176 19.17 17.2528 19.4166C17.088 19.6633 17 19.9533 17 20.25C17 20.6478 17.158 21.0294 17.4393 21.3107C17.7206 21.592 18.1022 21.75 18.5 21.75ZM26 21.75C26.2967 21.75 26.5867 21.662 26.8334 21.4972C27.08 21.3324 27.2723 21.0981 27.3858 20.824C27.4994 20.5499 27.5291 20.2483 27.4712 19.9574C27.4133 19.6664 27.2704 19.3991 27.0607 19.1893C26.8509 18.9796 26.5836 18.8367 26.2926 18.7788C26.0017 18.7209 25.7001 18.7506 25.426 18.8642C25.1519 18.9777 24.9176 19.17 24.7528 19.4166C24.588 19.6633 24.5 19.9533 24.5 20.25C24.5 20.6478 24.658 21.0294 24.9393 21.3107C25.2206 21.592 25.6022 21.75 26 21.75ZM18.5 27.75C18.7967 27.75 19.0867 27.662 19.3334 27.4972C19.58 27.3324 19.7723 27.0981 19.8858 26.824C19.9994 26.5499 20.0291 26.2483 19.9712 25.9574C19.9133 25.6664 19.7704 25.3991 19.5607 25.1893C19.3509 24.9796 19.0836 24.8367 18.7926 24.7788C18.5017 24.7209 18.2001 24.7506 17.926 24.8642C17.6519 24.9777 17.4176 25.17 17.2528 25.4166C17.088 25.6633 17 25.9533 17 26.25C17 26.6478 17.158 27.0294 17.4393 27.3107C17.7206 27.592 18.1022 27.75 18.5 27.75ZM26 27.75C26.2967 27.75 26.5867 27.662 26.8334 27.4972C27.08 27.3324 27.2723 27.0981 27.3858 26.824C27.4994 26.5499 27.5291 26.2483 27.4712 25.9574C27.4133 25.6664 27.2704 25.3991 27.0607 25.1893C26.8509 24.9796 26.5836 24.8367 26.2926 24.7788C26.0017 24.7209 25.7001 24.7506 25.426 24.8642C25.1519 24.9777 24.9176 25.17 24.7528 25.4166C24.588 25.6633 24.5 25.9533 24.5 26.25C24.5 26.6478 24.658 27.0294 24.9393 27.3107C25.2206 27.592 25.6022 27.75 26 27.75ZM11 21.75C11.2967 21.75 11.5867 21.662 11.8334 21.4972C12.08 21.3324 12.2723 21.0981 12.3858 20.824C12.4994 20.5499 12.5291 20.2483 12.4712 19.9574C12.4133 19.6664 12.2704 19.3991 12.0607 19.1893C11.8509 18.9796 11.5836 18.8367 11.2926 18.7788C11.0017 18.7209 10.7001 18.7506 10.426 18.8642C10.1519 18.9777 9.91762 19.17 9.7528 19.4166C9.58797 19.6633 9.5 19.9533 9.5 20.25C9.5 20.6478 9.65804 21.0294 9.93934 21.3107C10.2206 21.592 10.6022 21.75 11 21.75ZM29 6.75H27.5V5.25C27.5 4.85218 27.342 4.47064 27.0607 4.18934C26.7794 3.90804 26.3978 3.75 26 3.75C25.6022 3.75 25.2206 3.90804 24.9393 4.18934C24.658 4.47064 24.5 4.85218 24.5 5.25V6.75H12.5V5.25C12.5 4.85218 12.342 4.47064 12.0607 4.18934C11.7794 3.90804 11.3978 3.75 11 3.75C10.6022 3.75 10.2206 3.90804 9.93934 4.18934C9.65804 4.47064 9.5 4.85218 9.5 5.25V6.75H8C6.80653 6.75 5.66193 7.22411 4.81802 8.06802C3.97411 8.91193 3.5 10.0565 3.5 11.25V29.25C3.5 30.4435 3.97411 31.5881 4.81802 32.432C5.66193 33.2759 6.80653 33.75 8 33.75H29C30.1935 33.75 31.3381 33.2759 32.182 32.432C33.0259 31.5881 33.5 30.4435 33.5 29.25V11.25C33.5 10.0565 33.0259 8.91193 32.182 8.06802C31.3381 7.22411 30.1935 6.75 29 6.75ZM30.5 29.25C30.5 29.6478 30.342 30.0294 30.0607 30.3107C29.7794 30.592 29.3978 30.75 29 30.75H8C7.60218 30.75 7.22064 30.592 6.93934 30.3107C6.65804 30.0294 6.5 29.6478 6.5 29.25V15.75H30.5V29.25ZM30.5 12.75H6.5V11.25C6.5 10.8522 6.65804 10.4706 6.93934 10.1893C7.22064 9.90804 7.60218 9.75 8 9.75H29C29.3978 9.75 29.7794 9.90804 30.0607 10.1893C30.342 10.4706 30.5 10.8522 30.5 11.25V12.75ZM11 27.75C11.2967 27.75 11.5867 27.662 11.8334 27.4972C12.08 27.3324 12.2723 27.0981 12.3858 26.824C12.4994 26.5499 12.5291 26.2483 12.4712 25.9574C12.4133 25.6664 12.2704 25.3991 12.0607 25.1893C11.8509 24.9796 11.5836 24.8367 11.2926 24.7788C11.0017 24.7209 10.7001 24.7506 10.426 24.8642C10.1519 24.9777 9.91762 25.17 9.7528 25.4166C9.58797 25.6633 9.5 25.9533 9.5 26.25C9.5 26.6478 9.65804 27.0294 9.93934 27.3107C10.2206 27.592 10.6022 27.75 11 27.75Z"
                  fill="#20409B"
                />
              </svg>
              <p class="fs-14 fw-500 txt-pri mb-0 mt-2">Lịch làm việc</p>
            </div>
          </div>
          <div class="col-md-3 p-3">
            <div class="home-item">
              <svg
                width="36"
                height="37"
                viewBox="0 0 36 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M32.295 11.475C32.067 11.3433 31.8083 11.274 31.545 11.274C31.2817 11.274 31.023 11.3433 30.795 11.475L25.5 14.085C25.4573 12.9204 24.9644 11.8177 24.125 11.0092C23.2857 10.2006 22.1654 9.74922 21 9.75H7.5C6.30653 9.75 5.16193 10.2241 4.31802 11.068C3.47411 11.9119 3 13.0565 3 14.25V23.25C3 24.4435 3.47411 25.5881 4.31802 26.432C5.16193 27.2759 6.30653 27.75 7.5 27.75H21C22.1654 27.7508 23.2857 27.2994 24.125 26.4908C24.9644 25.6823 25.4573 24.5796 25.5 23.415L30.84 26.085C31.0445 26.1898 31.2703 26.2463 31.5 26.25C31.7808 26.2509 32.0563 26.1729 32.295 26.025C32.5112 25.8899 32.6893 25.7019 32.8127 25.4788C32.936 25.2558 33.0005 25.0049 33 24.75V12.75C33.0005 12.4951 32.936 12.2442 32.8127 12.0212C32.6893 11.7981 32.5112 11.6101 32.295 11.475ZM22.5 23.25C22.5 23.6478 22.342 24.0294 22.0607 24.3107C21.7794 24.592 21.3978 24.75 21 24.75H7.5C7.10218 24.75 6.72064 24.592 6.43934 24.3107C6.15804 24.0294 6 23.6478 6 23.25V14.25C6 13.8522 6.15804 13.4706 6.43934 13.1893C6.72064 12.908 7.10218 12.75 7.5 12.75H21C21.3978 12.75 21.7794 12.908 22.0607 13.1893C22.342 13.4706 22.5 13.8522 22.5 14.25V23.25ZM30 22.32L25.5 20.07V17.43L30 15.18V22.32Z"
                  fill="#20409B"
                />
              </svg>

              <p class="fs-14 fw-500 txt-pri mb-0 mt-2">{{ $t('lbl_meeting_room') }}</p>
            </div>
          </div>
          <div class="col-md-3 p-3">
            <div class="home-item">
              <svg
                width="37"
                height="37"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.575 3.76514C16.25 3.76514 14.345 5.65514 14.345 7.99514C14.345 10.3351 16.235 12.2251 18.575 12.2251C20.915 12.2251 22.805 10.3351 22.805 7.99514C22.805 5.65514 20.915 3.76514 18.575 3.76514Z"
                  stroke="#03267A"
                  stroke-width="2"
                />
                <path
                  d="M8.07497 21.5552C5.74997 21.5552 3.84497 23.4452 3.84497 25.7852C3.84497 28.1252 5.73497 30.0152 8.07497 30.0152C10.415 30.0152 12.305 28.1252 12.305 25.7852C12.305 23.4452 10.4 21.5552 8.07497 21.5552Z"
                  stroke="#03267A"
                  stroke-width="2"
                />
                <path
                  d="M28.9251 21.5552C26.6001 21.5552 24.6951 23.4452 24.6951 25.7852C24.6951 28.1252 26.5851 30.0152 28.9251 30.0152C31.2651 30.0152 33.1551 28.1252 33.1551 25.7852C33.1551 23.4452 31.2651 21.5552 28.9251 21.5552Z"
                  stroke="#03267A"
                  stroke-width="2"
                />
                <path
                  d="M22.9473 31.9792C23.7192 31.6785 24.1012 30.809 23.8005 30.0371C23.4998 29.2652 22.6303 28.8832 21.8584 29.1839L22.9473 31.9792ZM15.136 30.9515L15.5386 29.5065L15.5386 29.5065L15.136 30.9515ZM14.7109 29.2364C13.9353 28.9451 13.0705 29.3377 12.7793 30.1132C12.488 30.8888 12.8806 31.7536 13.6562 32.0448L14.7109 29.2364ZM21.8584 29.1839C19.8695 29.9586 17.6504 30.0948 15.5386 29.5065L14.7335 32.3965C17.4857 33.1632 20.3691 32.9836 22.9473 31.9792L21.8584 29.1839ZM15.5386 29.5065C15.2607 29.4291 14.9846 29.3391 14.7109 29.2364L13.6562 32.0448C14.0122 32.1785 14.3716 32.2957 14.7335 32.3965L15.5386 29.5065Z"
                  fill="#03267A"
                />
                <path
                  d="M10.3679 10.4131C11.0143 9.89497 11.9584 9.99891 12.4765 10.6453C12.9947 11.2917 12.8907 12.2357 12.2444 12.7539L10.3679 10.4131ZM7.35236 17.6918L8.80501 18.0657L8.80501 18.0657L7.35236 17.6918ZM8.62513 18.9175C8.48959 19.7348 7.71719 20.2875 6.89993 20.1519C6.08266 20.0164 5.53002 19.244 5.66556 18.4267L8.62513 18.9175ZM12.2444 12.7539C10.579 14.0889 9.35144 15.9426 8.80501 18.0657L5.8997 17.3179C6.61182 14.5511 8.20903 12.1438 10.3679 10.4131L12.2444 12.7539ZM8.80501 18.0657C8.73312 18.345 8.67297 18.6291 8.62513 18.9175L5.66556 18.4267C5.72778 18.0515 5.80607 17.6817 5.8997 17.3179L8.80501 18.0657Z"
                  fill="#03267A"
                />
                <path
                  d="M26.6321 10.4131C25.9857 9.89497 25.0416 9.99891 24.5235 10.6453C24.0053 11.2917 24.1093 12.2357 24.7556 12.7539L26.6321 10.4131ZM29.6476 17.6918L28.195 18.0657L28.195 18.0657L29.6476 17.6918ZM28.3749 18.9175C28.5104 19.7348 29.2828 20.2875 30.1001 20.1519C30.9173 20.0164 31.47 19.244 31.3344 18.4267L28.3749 18.9175ZM24.7556 12.7539C26.421 14.0889 27.6486 15.9426 28.195 18.0657L31.1003 17.3179C30.3882 14.5511 28.791 12.1438 26.6321 10.4131L24.7556 12.7539ZM28.195 18.0657C28.2669 18.345 28.327 18.6291 28.3749 18.9175L31.3344 18.4267C31.2722 18.0515 31.1939 17.6817 31.1003 17.3179L28.195 18.0657Z"
                  fill="#03267A"
                />
              </svg>

              <p class="fs-14 fw-500 txt-pri mb-0 mt-2">Họp/Hội chẩn</p>
            </div>
          </div>
          <div class="col-md-3 p-3">
            <div class="home-item">
              <svg
                width="36"
                height="37"
                viewBox="0 0 36 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M28.5 12.75H27V8.25C27 7.05653 26.5259 5.91193 25.682 5.06802C24.8381 4.22411 23.6935 3.75 22.5 3.75H7.5C6.30653 3.75 5.16193 4.22411 4.31802 5.06802C3.47411 5.91193 3 7.05653 3 8.25V26.25C3.00148 26.5461 3.09058 26.8352 3.25608 27.0808C3.42158 27.3264 3.65607 27.5175 3.93 27.63C4.10802 27.714 4.30324 27.7551 4.5 27.75C4.69741 27.7511 4.8931 27.7133 5.07586 27.6387C5.25862 27.564 5.42484 27.454 5.565 27.315L9.78 23.085H12V25.245C12 26.4385 12.4741 27.5831 13.318 28.427C14.1619 29.2709 15.3065 29.745 16.5 29.745H26.88L30.435 33.315C30.5752 33.454 30.7414 33.564 30.9241 33.6387C31.1069 33.7133 31.3026 33.7511 31.5 33.75C31.6968 33.7551 31.892 33.714 32.07 33.63C32.3439 33.5175 32.5784 33.3264 32.7439 33.0808C32.9094 32.8352 32.9985 32.5461 33 32.25V17.25C33 16.0565 32.5259 14.9119 31.682 14.068C30.8381 13.2241 29.6935 12.75 28.5 12.75ZM12 17.25V20.085H9.165C8.96759 20.0839 8.7719 20.1217 8.58914 20.1963C8.40638 20.271 8.24016 20.381 8.1 20.52L6 22.635V8.25C6 7.85218 6.15804 7.47064 6.43934 7.18934C6.72064 6.90804 7.10218 6.75 7.5 6.75H22.5C22.8978 6.75 23.2794 6.90804 23.5607 7.18934C23.842 7.47064 24 7.85218 24 8.25V12.75H16.5C15.3065 12.75 14.1619 13.2241 13.318 14.068C12.4741 14.9119 12 16.0565 12 17.25ZM30 28.635L28.5 27.135C28.3611 26.9933 28.1954 26.8805 28.0126 26.8033C27.8298 26.726 27.6335 26.6858 27.435 26.685H16.5C16.1022 26.685 15.7206 26.527 15.4393 26.2457C15.158 25.9644 15 25.5828 15 25.185V17.25C15 16.8522 15.158 16.4706 15.4393 16.1893C15.7206 15.908 16.1022 15.75 16.5 15.75H28.5C28.8978 15.75 29.2794 15.908 29.5607 16.1893C29.842 16.4706 30 16.8522 30 17.25V28.635Z"
                  fill="#20409B"
                />
              </svg>

              <p class="fs-14 fw-500 txt-pri mb-0 mt-2">Conversation</p>
            </div>
          </div>
          <div class="col-md-3 p-3">
            <div class="home-item">
              <svg
                width="36"
                height="37"
                viewBox="0 0 36 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M34.17 16.305C34.0288 16.131 33.8504 15.9908 33.648 15.8948C33.4455 15.7987 33.2241 15.7493 33 15.75H30V14.25C30 13.0566 29.5259 11.912 28.682 11.0681C27.8381 10.2241 26.6935 9.75003 25.5 9.75003H16.08L15.6 8.25003C15.2888 7.36988 14.7116 6.60829 13.9484 6.07077C13.1851 5.53326 12.2735 5.24643 11.34 5.25003H6C4.80653 5.25003 3.66193 5.72414 2.81802 6.56805C1.97411 7.41197 1.5 8.55656 1.5 9.75003V27.75C1.5 28.9435 1.97411 30.0881 2.81802 30.932C3.66193 31.7759 4.80653 32.25 6 32.25H27.6C28.6218 32.2471 29.6122 31.8964 30.4083 31.2557C31.2043 30.6151 31.7586 29.7226 31.98 28.725L34.5 17.58C34.5456 17.3564 34.5396 17.1253 34.4824 16.9044C34.4252 16.6834 34.3184 16.4784 34.17 16.305ZM8.055 28.08C7.9788 28.4184 7.78769 28.7199 7.5142 28.9332C7.24071 29.1466 6.90174 29.2585 6.555 29.25H6C5.60218 29.25 5.22064 29.092 4.93934 28.8107C4.65804 28.5294 4.5 28.1479 4.5 27.75V9.75003C4.5 9.35221 4.65804 8.97068 4.93934 8.68937C5.22064 8.40807 5.60218 8.25003 6 8.25003H11.34C11.6671 8.23296 11.9908 8.32342 12.2617 8.50761C12.5325 8.69179 12.7356 8.95956 12.84 9.27003L13.65 11.73C13.7463 12.0162 13.9266 12.2666 14.1675 12.4485C14.4083 12.6305 14.6985 12.7356 15 12.75H25.5C25.8978 12.75 26.2794 12.9081 26.5607 13.1894C26.842 13.4707 27 13.8522 27 14.25V15.75H12C11.6533 15.7416 11.3143 15.8535 11.0408 16.0668C10.7673 16.2802 10.5762 16.5817 10.5 16.92L8.055 28.08ZM29.055 28.08C28.9788 28.4184 28.7877 28.7199 28.5142 28.9332C28.2407 29.1466 27.9017 29.2585 27.555 29.25H10.815C10.8925 29.0829 10.9479 28.9064 10.98 28.725L13.2 18.75H31.2L29.055 28.08Z"
                  fill="#20409B"
                />
              </svg>

              <p class="fs-14 fw-500 txt-pri mb-0 mt-2">Tài nguyên</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 px-3 d-flex align-items-center">
            <svg
              width="28"
              height="29"
              viewBox="0 0 28 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8.16663 11.5833L14 17.4166L19.8333 11.5833H8.16663Z" fill="#1D2939" />
            </svg>
            <p class="fs-16 txt-grey-700 mb-0">{{ ws && ws.org && ws.org.name }}</p>
          </div>
          <div class="col-md-3 p-3">
            <div class="home-item">
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M31.5 15.0002C31.697 15.0003 31.8921 14.9615 32.0741 14.8862C32.2561 14.8108 32.4215 14.7003 32.5608 14.561C32.7001 14.4217 32.8106 14.2563 32.8859 14.0743C32.9613 13.8923 33.0001 13.6972 33 13.5002V9.00024C33.0001 8.6855 32.9011 8.37872 32.7171 8.12341C32.533 7.8681 32.2733 7.67723 31.9746 7.57788L18.4746 3.07788C18.1665 2.97534 17.8335 2.97534 17.5254 3.07788L4.02539 7.57788C3.72674 7.67723 3.46696 7.8681 3.28291 8.12341C3.09885 8.37872 2.99987 8.6855 3 9.00024V13.5002C2.99995 13.6972 3.03871 13.8923 3.11408 14.0743C3.18944 14.2563 3.29993 14.4217 3.43923 14.561C3.57852 14.7003 3.7439 14.8108 3.92591 14.8862C4.10793 14.9615 4.303 15.0003 4.5 15.0002H6V25.7766C5.12511 26.0848 4.36705 26.6562 3.8299 27.4125C3.29275 28.1687 3.00285 29.0727 3 30.0002V33.0002C2.99995 33.1972 3.03871 33.3923 3.11408 33.5743C3.18944 33.7563 3.29993 33.9217 3.43923 34.061C3.57852 34.2003 3.7439 34.3108 3.92591 34.3862C4.10793 34.4615 4.303 34.5003 4.5 34.5002H31.5C31.697 34.5003 31.8921 34.4615 32.0741 34.3862C32.2561 34.3108 32.4215 34.2003 32.5608 34.061C32.7001 33.9217 32.8106 33.7563 32.8859 33.5743C32.9613 33.3923 33.0001 33.1972 33 33.0002V30.0002C32.9971 29.0727 32.7072 28.1687 32.1701 27.4125C31.633 26.6562 30.8749 26.0848 30 25.7766V15.0002H31.5ZM30 31.5002H6V30.0002C6.0004 29.6025 6.15856 29.2212 6.43978 28.94C6.721 28.6588 7.1023 28.5006 7.5 28.5002H28.5C28.8977 28.5006 29.279 28.6588 29.5602 28.94C29.8414 29.2212 29.9996 29.6025 30 30.0002V31.5002ZM9 25.5002V15.0002H12V25.5002H9ZM15 25.5002V15.0002H21V25.5002H15ZM24 25.5002V15.0002H27V25.5002H24ZM6 12.0002V10.0813L18 6.08079L30 10.0813V12.0002H6Z"
                  fill="#20409B"
                />
              </svg>

              <p class="fs-14 fw-500 txt-pri mb-0 mt-2">Hội trường</p>
            </div>
          </div>
          <div class="col-md-3 p-3">
            <div class="home-item">
              <svg
                width="36"
                height="37"
                viewBox="0 0 36 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M28.5 12.75H27V8.25C27 7.05653 26.5259 5.91193 25.682 5.06802C24.8381 4.22411 23.6935 3.75 22.5 3.75H7.5C6.30653 3.75 5.16193 4.22411 4.31802 5.06802C3.47411 5.91193 3 7.05653 3 8.25V26.25C3.00148 26.5461 3.09058 26.8352 3.25608 27.0808C3.42158 27.3264 3.65607 27.5175 3.93 27.63C4.10802 27.714 4.30324 27.7551 4.5 27.75C4.69741 27.7511 4.8931 27.7133 5.07586 27.6387C5.25862 27.564 5.42484 27.454 5.565 27.315L9.78 23.085H12V25.245C12 26.4385 12.4741 27.5831 13.318 28.427C14.1619 29.2709 15.3065 29.745 16.5 29.745H26.88L30.435 33.315C30.5752 33.454 30.7414 33.564 30.9241 33.6387C31.1069 33.7133 31.3026 33.7511 31.5 33.75C31.6968 33.7551 31.892 33.714 32.07 33.63C32.3439 33.5175 32.5784 33.3264 32.7439 33.0808C32.9094 32.8352 32.9985 32.5461 33 32.25V17.25C33 16.0565 32.5259 14.9119 31.682 14.068C30.8381 13.2241 29.6935 12.75 28.5 12.75ZM12 17.25V20.085H9.165C8.96759 20.0839 8.7719 20.1217 8.58914 20.1963C8.40638 20.271 8.24016 20.381 8.1 20.52L6 22.635V8.25C6 7.85218 6.15804 7.47064 6.43934 7.18934C6.72064 6.90804 7.10218 6.75 7.5 6.75H22.5C22.8978 6.75 23.2794 6.90804 23.5607 7.18934C23.842 7.47064 24 7.85218 24 8.25V12.75H16.5C15.3065 12.75 14.1619 13.2241 13.318 14.068C12.4741 14.9119 12 16.0565 12 17.25ZM30 28.635L28.5 27.135C28.3611 26.9933 28.1954 26.8805 28.0126 26.8033C27.8298 26.726 27.6335 26.6858 27.435 26.685H16.5C16.1022 26.685 15.7206 26.527 15.4393 26.2457C15.158 25.9644 15 25.5828 15 25.185V17.25C15 16.8522 15.158 16.4706 15.4393 16.1893C15.7206 15.908 16.1022 15.75 16.5 15.75H28.5C28.8978 15.75 29.2794 15.908 29.5607 16.1893C29.842 16.4706 30 16.8522 30 17.25V28.635Z"
                  fill="#20409B"
                />
              </svg>

              <p class="fs-14 fw-500 txt-pri mb-0 mt-2">Conversation</p>
            </div>
          </div>
          <div class="col-md-3 p-3">
            <div class="home-item">
              <svg
                width="36"
                height="37"
                viewBox="0 0 36 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M34.17 16.305C34.0288 16.131 33.8504 15.9908 33.648 15.8948C33.4455 15.7987 33.2241 15.7493 33 15.75H30V14.25C30 13.0566 29.5259 11.912 28.682 11.0681C27.8381 10.2241 26.6935 9.75003 25.5 9.75003H16.08L15.6 8.25003C15.2888 7.36988 14.7116 6.60829 13.9484 6.07077C13.1851 5.53326 12.2735 5.24643 11.34 5.25003H6C4.80653 5.25003 3.66193 5.72414 2.81802 6.56805C1.97411 7.41197 1.5 8.55656 1.5 9.75003V27.75C1.5 28.9435 1.97411 30.0881 2.81802 30.932C3.66193 31.7759 4.80653 32.25 6 32.25H27.6C28.6218 32.2471 29.6122 31.8964 30.4083 31.2557C31.2043 30.6151 31.7586 29.7226 31.98 28.725L34.5 17.58C34.5456 17.3564 34.5396 17.1253 34.4824 16.9044C34.4252 16.6834 34.3184 16.4784 34.17 16.305ZM8.055 28.08C7.9788 28.4184 7.78769 28.7199 7.5142 28.9332C7.24071 29.1466 6.90174 29.2585 6.555 29.25H6C5.60218 29.25 5.22064 29.092 4.93934 28.8107C4.65804 28.5294 4.5 28.1479 4.5 27.75V9.75003C4.5 9.35221 4.65804 8.97068 4.93934 8.68937C5.22064 8.40807 5.60218 8.25003 6 8.25003H11.34C11.6671 8.23296 11.9908 8.32342 12.2617 8.50761C12.5325 8.69179 12.7356 8.95956 12.84 9.27003L13.65 11.73C13.7463 12.0162 13.9266 12.2666 14.1675 12.4485C14.4083 12.6305 14.6985 12.7356 15 12.75H25.5C25.8978 12.75 26.2794 12.9081 26.5607 13.1894C26.842 13.4707 27 13.8522 27 14.25V15.75H12C11.6533 15.7416 11.3143 15.8535 11.0408 16.0668C10.7673 16.2802 10.5762 16.5817 10.5 16.92L8.055 28.08ZM29.055 28.08C28.9788 28.4184 28.7877 28.7199 28.5142 28.9332C28.2407 29.1466 27.9017 29.2585 27.555 29.25H10.815C10.8925 29.0829 10.9479 28.9064 10.98 28.725L13.2 18.75H31.2L29.055 28.08Z"
                  fill="#20409B"
                />
              </svg>

              <p class="fs-14 fw-500 txt-pri mb-0 mt-2">Tài nguyên</p>
            </div>
          </div>
          <div class="col-md-3 p-3">
            <div class="home-item">
              <svg
                width="37"
                height="37"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.575 3.76514C16.25 3.76514 14.345 5.65514 14.345 7.99514C14.345 10.3351 16.235 12.2251 18.575 12.2251C20.915 12.2251 22.805 10.3351 22.805 7.99514C22.805 5.65514 20.915 3.76514 18.575 3.76514Z"
                  stroke="#03267A"
                  stroke-width="2"
                />
                <path
                  d="M8.07497 21.5552C5.74997 21.5552 3.84497 23.4452 3.84497 25.7852C3.84497 28.1252 5.73497 30.0152 8.07497 30.0152C10.415 30.0152 12.305 28.1252 12.305 25.7852C12.305 23.4452 10.4 21.5552 8.07497 21.5552Z"
                  stroke="#03267A"
                  stroke-width="2"
                />
                <path
                  d="M28.9251 21.5552C26.6001 21.5552 24.6951 23.4452 24.6951 25.7852C24.6951 28.1252 26.5851 30.0152 28.9251 30.0152C31.2651 30.0152 33.1551 28.1252 33.1551 25.7852C33.1551 23.4452 31.2651 21.5552 28.9251 21.5552Z"
                  stroke="#03267A"
                  stroke-width="2"
                />
                <path
                  d="M22.9473 31.9792C23.7192 31.6785 24.1012 30.809 23.8005 30.0371C23.4998 29.2652 22.6303 28.8832 21.8584 29.1839L22.9473 31.9792ZM15.136 30.9515L15.5386 29.5065L15.5386 29.5065L15.136 30.9515ZM14.7109 29.2364C13.9353 28.9451 13.0705 29.3377 12.7793 30.1132C12.488 30.8888 12.8806 31.7536 13.6562 32.0448L14.7109 29.2364ZM21.8584 29.1839C19.8695 29.9586 17.6504 30.0948 15.5386 29.5065L14.7335 32.3965C17.4857 33.1632 20.3691 32.9836 22.9473 31.9792L21.8584 29.1839ZM15.5386 29.5065C15.2607 29.4291 14.9846 29.3391 14.7109 29.2364L13.6562 32.0448C14.0122 32.1785 14.3716 32.2957 14.7335 32.3965L15.5386 29.5065Z"
                  fill="#03267A"
                />
                <path
                  d="M10.3679 10.4131C11.0143 9.89497 11.9584 9.99891 12.4765 10.6453C12.9947 11.2917 12.8907 12.2357 12.2444 12.7539L10.3679 10.4131ZM7.35236 17.6918L8.80501 18.0657L8.80501 18.0657L7.35236 17.6918ZM8.62513 18.9175C8.48959 19.7348 7.71719 20.2875 6.89993 20.1519C6.08266 20.0164 5.53002 19.244 5.66556 18.4267L8.62513 18.9175ZM12.2444 12.7539C10.579 14.0889 9.35144 15.9426 8.80501 18.0657L5.8997 17.3179C6.61182 14.5511 8.20903 12.1438 10.3679 10.4131L12.2444 12.7539ZM8.80501 18.0657C8.73312 18.345 8.67297 18.6291 8.62513 18.9175L5.66556 18.4267C5.72778 18.0515 5.80607 17.6817 5.8997 17.3179L8.80501 18.0657Z"
                  fill="#03267A"
                />
                <path
                  d="M26.6321 10.4131C25.9857 9.89497 25.0416 9.99891 24.5235 10.6453C24.0053 11.2917 24.1093 12.2357 24.7556 12.7539L26.6321 10.4131ZM29.6476 17.6918L28.195 18.0657L28.195 18.0657L29.6476 17.6918ZM28.3749 18.9175C28.5104 19.7348 29.2828 20.2875 30.1001 20.1519C30.9173 20.0164 31.47 19.244 31.3344 18.4267L28.3749 18.9175ZM24.7556 12.7539C26.421 14.0889 27.6486 15.9426 28.195 18.0657L31.1003 17.3179C30.3882 14.5511 28.791 12.1438 26.6321 10.4131L24.7556 12.7539ZM28.195 18.0657C28.2669 18.345 28.327 18.6291 28.3749 18.9175L31.3344 18.4267C31.2722 18.0515 31.1939 17.6817 31.1003 17.3179L28.195 18.0657Z"
                  fill="#03267A"
                />
              </svg>

              <p class="fs-14 fw-500 txt-pri mb-0 mt-2">Họp/Hội chẩn</p>
            </div>
          </div>
        </div>
      </div>
      <div class="p-4">
        <img
          src="https://i.ibb.co/cyXcvV2/Setting-Organization.png"
          alt="Setting-Organization"
          border="0"
          class="w-100"
          v-if="type === 'set'"
        />
        <img
          src="https://i.ibb.co/dpxgXzW/nhan-su.png"
          alt="nhan-su"
          border="0"
          class="w-100"
          v-if="type === 'ns'"
        />
        <img
          src="https://i.ibb.co/MPC6WkH/tainguyen.png"
          alt="tainguyen"
          border="0"
          class="w-100"
          v-if="type === 'tn'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import Sidebar from './Sidebar.vue'
export default {
  name: 'ConceptNewWsOrgHome',
  components: { Sidebar },
  data () {
    return {
      moment
    }
  },
  computed: {
    isAdminOrg () {
      if (this.user && this.ws) {
        return (
          this.ws?.org?.members?.find(m => m.user_id === this.user.id)?.role ===
            1 || this.ws?.org?.owner_id === this.user.id
        )
      }
    },
    isAdminWs () {
      if (this.user && this.ws) {
        return (
          this.ws?.members?.find(m => m.user_id === this.user.id)?.role === 1 ||
          this.ws?.owner_id === this.user.id
        )
      }
    },
    type () {
      return this.$route.query.type
    },
    ...mapState({
      user: state => state.concept.user,
      mode: state => state.concept.mode,
      ws: state => state.concept.ws
    })
  },
  methods: {
    switchMode () {
      let mode = this.mode === 1 ? 2 : 1
      let concept = this.$store.getters.getConcept
      concept.mode = mode
      this.$store.commit('setConcept', { concept })
      let query = Object.assign({}, this.$route.query)
      delete query.type
      query.i = moment().unix()
      this.$router.push({ query }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.toggle-view-mode {
  display: flex;
  height: 48px;
  align-items: center;
  align-content: center;
  background-color: #fafafa;
  border-radius: 24px;
  padding: 12px 24px;
  cursor: pointer;
}
.home-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 115px;
  width: 100%;
  background: #fff;
  border: solid 1px #c3cae7;
  border-radius: 8px;
}
.home-content {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>